import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item"]

  filter() {
    const query = this.hasInputTarget ? this.inputTarget.value.toLowerCase().trim() : ""
    const terms = query ? query.split(/\s+/) : []

    this.itemTargets.forEach((item) => {
      const value = (item.dataset.filterValue || item.textContent || "").toLowerCase()
      const matches = terms.length === 0 || terms.every((term) => value.includes(term))
      item.classList.toggle("hidden", !matches)
    })
  }
}
